import { render, staticRenderFns } from "./AssignPackageDialog.vue?vue&type=template&id=1fae7313"
import script from "./AssignPackageDialog.vue?vue&type=script&lang=js"
export * from "./AssignPackageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fae7313')) {
      api.createRecord('1fae7313', component.options)
    } else {
      api.reload('1fae7313', component.options)
    }
    module.hot.accept("./AssignPackageDialog.vue?vue&type=template&id=1fae7313", function () {
      api.rerender('1fae7313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/AssignPackageDialog.vue"
export default component.exports